import './styles/style.scss';

export { default } from './Addons';
export { default as Addon } from './Addon';



// WEBPACK FOOTER //
// ./src/components/Forms/Input/Addons/index.js